<template>
  <Loading v-if="!didLoadData"/>
  <v-container fluid v-else>
    <BackButton :target="{name: 'Beacons'}">Majáky</BackButton>
    <ModuleHeader>
      <RefreshButton @click="refreshBeaconPurposes">
        <div class="text-h5 font-weight-bold">Účely majáků</div>
      </RefreshButton>
      <PrimaryButton :to="{name: 'BeaconPurposeDetail', params: {id: 'new'}}">+ Nový</PrimaryButton>
    </ModuleHeader>
    <v-row>
      <v-col cols="12">
        <v-data-table
            :headers="dataTableHeaders"
            :items="purposes"
            mobile-breakpoint="0"
            :header-props="{
              sortByText: 'Řadit podle'
            }"
            items-per-page-text="Počet řádků na stránku"
            page-text="{0}-{1} z {2}"
            :items-per-page-options="[
              {value: 10, title: '10'},
              {value: 25, title: '25'},
              {value: 50, title: '50'},
              {value: 100, title: '100'},
              {value: -1, title: 'Všechny'}
            ]"
            items-per-page="25"
            :sort-by="[{ key: $query.sort, order: $query.order }]"
            @update:sort-by="s => { $query.sort = s[0]?.key; $query.order = s[0]?.order; }"
            v-model.items-per-page="$query.rowsPerPage"
            v-model.page="$query.page"
        >
          <template v-slot:no-data>
            Žádná dostupná data
          </template>
          <template v-slot:item.name="{ item }">
            <b class="pointer light-green--text" @click="goToDetail(item.id)">{{ item.name }}</b>
          </template>
          <template v-slot:item.actions="{ item }">
            <DeleteIcon @click="attemptToDeleteBeaconPurpose(item)"/>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import PrimaryButton from "@/components/buttons/PrimaryButton";
import RefreshButton from "@/components/buttons/RefreshButton";
import ModuleHeader from "@/components/layout/ModuleHeader";
import BackButton from "@/components/layout/BackButton";
import {mapActions, mapGetters} from "vuex";
import DeleteIcon from "@/components/buttons/DeleteIcon";
import Loading from "@/components/Loading";

export default {
  name: "BeaconPurposes",
  components: {Loading, DeleteIcon, BackButton, ModuleHeader, PrimaryButton, RefreshButton},

  mounted() {
    this.fetchBeaconPurposes();
  },

  data() {
    return {
      dataTableHeaders: [
        {
          title: 'Akce',
          value: 'actions',
          width: '5%',
          sortable: false,
        },
        {
          title: 'Název',
          value: 'name',
          width: '95%',
          sortable: true,
        },
      ],
    }
  },

  computed: {
    ...mapGetters("BeaconPurposes", ["purposes", "didLoadBeaconPurposes"]),

    didLoadData() {
      return this.didLoadBeaconPurposes
    },
  },

  methods: {
    ...mapActions("BeaconPurposes", ["fetchBeaconPurposes", "deleteBeaconPurpose"]),
    
    refreshBeaconPurposes() {
      this.fetchBeaconPurposes();
    },

    goToDetail(beaconPurposeId) {
      this.$router.push({name: 'BeaconPurposeDetail', params: {id: beaconPurposeId}});
    },

    attemptToDeleteBeaconPurpose(item) {
      if (confirm('Opravdu chcete smazat účel "' + item.name + '"?')) {
        this.deleteBeaconPurpose(item.id);
      }
    },

  }
}
</script>

<style scoped>
</style>